import { render, staticRenderFns } from "./ProjectSearch.vue?vue&type=template&id=15b747b0"
import script from "./ProjectSearch.vue?vue&type=script&lang=js"
export * from "./ProjectSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports